import FAQAccordion from "@/components/FAQAccordion";
import { faqs } from "@/data/faq";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FAQPage() {
  return (
    <div>
      <section className="pt-16 md:pt-24 pb-16 md:pb-20 border-b border-[#27272a] relative overflow-hidden">
        <div className="absolute inset-0 radial-fade" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-3xl">
            <div className="eyebrow mb-6">
              <span className="gold-line" />
              FAQ
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
              Answers, <span className="text-[#C8A24B]">plainly said.</span>
            </h1>
            <p className="mt-8 text-lg text-[#a1a1aa] leading-relaxed max-w-2xl">
              Common questions from agents, agencies, and professionals
              considering Agent Marketing.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <FAQAccordion items={faqs} testIdPrefix="full-faq" />
          <div className="mt-14 pt-10 border-t border-[#27272a] flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <div className="text-[10px] tracking-[0.28em] uppercase text-[#C8A24B] mb-2">
                Still Have Questions
              </div>
              <p className="text-[#d4d4d8] max-w-md">
                A short fit conversation usually answers everything. Start
                here.
              </p>
            </div>
            <Link to="/contact" className="btn-gold">
              Build My Growth Plan <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
